import { PluginStore } from "graylog-web-plugin/plugin";
import iterateConfirmationHooks from "views/hooks/IterateConfirmationHooks";
const defaultConfirm = async () => window.confirm("Do you really want to delete this dashboard page?");
const ConfirmDeletingDashboardPage = async (dashboardId, activeQueryId, widgetIds) => {
  const _widgetIds = widgetIds.map((ids) => ids.toArray()).toObject();
  const deletingDashboardPageHooks = PluginStore.exports("views.hooks.confirmDeletingDashboardPage");
  return iterateConfirmationHooks(
    [...deletingDashboardPageHooks, defaultConfirm],
    dashboardId,
    activeQueryId,
    _widgetIds
  );
};
export default ConfirmDeletingDashboardPage;
